import React from "react";

import '../../style_new.css';

const serviceData = [
  {
    title: "Architectural Design",
    image: "./images/service-1.jpg",
    description: "Innovative, compliant designs focused on function, aesthetics, and client vision.",
  },
  {
    title: "Structural Engineering Services",
    image: "./images/service-2.jpg",
    description: "Structural design and analysis to ensure the integrity and safety of buildings and infrastructure.",
  },
  {
    title: "Hydrological Engineering",
    image: "./images/project-2.jpg",
    description: "Water management solutions, including drainage systems, flood control, and sustainable water use planning.",
  },
  {
    title: "Residential Construction",
    image: "./images/carousel-1.jpg",
    description: "Safe and professional electrical wiring and appliance installations.",
  },
  {
    title: "Commercial, Educational, and Industrial Projects",
    image: "./images/project-17.jpg",
    description: "Construction of office buildings, schools, universities, factories, and warehouses for both public and private sectors.",
  },
  {
    title: "Religious Buildings Construction",
    image: "./images/project-5.jpg",
    description: "Specialized construction of churches and other worship facilities for religious organizations.",
  },
];

const Services = () => {
  return (
    <>
      {/* services section start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-end mb-5">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="border-start border-5 border-primary ps-4">
                <h6 className="text-body text-uppercase mb-2">Our Services</h6>
                <h1 className="display-6 mb-0">
                  Construction And Renovation Solutions
                </h1>
              </div>
            </div>
         
          </div>
          <div className="row g-4 justify-content-center">
            {serviceData.map((service, index) => (
              <div
                key={index}
                className="col-lg-4 col-md-6 wow fadeInUp"
                data-wow-delay={`${0.1 + (index % 3) * 0.2}s`}
              >
                <div className="service-item bg-light overflow-hidden h-100">
                  <img className="img-fluid" src={service.image} alt={service.title} />
                  <div className="service-text position-relative text-center h-100 p-4">
                    <h5 className="mb-3">{service.title}</h5>
                    <p>{service.description}</p>
                   
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* services section end */}
    </>
  );
};



  
export default Services;